import { Reveal, Overline } from "@/components/Reveal";

export default function SalesGrid({ overline, title, cards, icons = [], surface = false }) {
  return (
    <section className={`${surface ? "bg-mist" : "bg-paper"} py-20 md:py-28 border-t border-line`} data-testid="sales-grid">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <Overline>{overline}</Overline>
          <h2 className="mt-4 font-serif font-semibold text-3xl sm:text-4xl md:text-5xl tracking-tight max-w-3xl leading-[1.08]">
            {title}
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {cards.map((c, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={i} delay={(i % 3) * 0.06}>
                <div className="h-full bg-paper border border-line rounded-2xl p-7 shadow-sm hover:shadow-md transition-shadow">
                  {Icon && (
                    <div className="h-12 w-12 rounded-xl bg-brand/10 text-brand flex items-center justify-center">
                      <Icon size={24} strokeWidth={2} />
                    </div>
                  )}
                  <h3 className="mt-5 text-lg font-semibold tracking-tight">{c.t}</h3>
                  <p className="mt-2 text-stone leading-relaxed text-sm">{c.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
